import { TextField } from "./AdministrationFields";
import { GUARDIAN_CURATOR_FIELDS } from "../model/administrationConstants";
import { emptyStyle, primaryButtonStyle, secondaryButtonStyle } from "../styles/administrationModalStyles";
import { creditCellStyle, creditHeaderStyle, creditTableContainerStyle, creditTableStyle } from "../styles/administrationStyles";

export function GuardianCuratorTable({ rows, drafts, loading, savingIds, onChange, onSave, onCancel }) {
    if (loading) return <p style={emptyStyle}>Chargement…</p>;
    if (rows.length === 0) return <p style={emptyStyle}>Aucune ligne Tuteur Curateur.</p>;

    return (
        <div style={creditTableContainerStyle}>
            <table style={{ ...creditTableStyle, minWidth: "1900px" }}>
                <thead>
                    <tr>
                        {GUARDIAN_CURATOR_FIELDS.map(([, label]) => (
                            <th key={label} style={creditHeaderStyle}>{label}</th>
                        ))}
                        <th style={creditHeaderStyle}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map(row => {
                        const current = drafts[row.id] || row;
                        const dirty = Boolean(drafts[row.id]);
                        const saving = Boolean(savingIds[row.id]);
                        return (
                            <tr key={row.id} style={{ background: dirty ? "#eef2ff" : "white" }}>
                                {GUARDIAN_CURATOR_FIELDS.map(([field, label]) => (
                                    <td key={field} style={{ ...creditCellStyle, minWidth: field === "remarks" ? "260px" : "150px" }}>
                                        <TextField
                                            label={`${label} ${row.patientName}`}
                                            value={current[field]}
                                            multiline={field === "remarks"}
                                            onChange={value => onChange(row, { [field]: value })}
                                        />
                                    </td>
                                ))}
                                <td style={creditCellStyle}>
                                    {dirty ? (
                                        <div style={{ display: "grid", gap: "7px" }}>
                                            <button type="button" disabled={saving} onClick={() => onSave(row.id)} style={primaryButtonStyle}>
                                                {saving ? "Enregistrement…" : "Enregistrer"}
                                            </button>
                                            <button type="button" disabled={saving} onClick={() => onCancel(row.id)} style={secondaryButtonStyle}>
                                                Annuler
                                            </button>
                                        </div>
                                    ) : row.updatedAt ? (
                                        <small style={{ color: "#94a3b8" }}>
                                            {new Date(row.updatedAt).toLocaleDateString("fr-FR")}<br />{row.updatedBy || ""}
                                        </small>
                                    ) : <span style={{ color: "#94a3b8" }}>—</span>}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}
